import React, { FC } from 'react'
import cx from 'classnames'

import { ActionButtonProps } from '../ActionButton'

import * as SC from './styled'

export type FooterProps = {
  className?: string
  links: Array<ActionButtonProps>
}

const Footer: FC<FooterProps> = (props) => {
  const { className, links } = props

  return (
    <SC.Footer className={cx(className)}>
      {links.map((link, idx) => (
        <SC.Link variant="link" key={idx} {...link} />
      ))}
    </SC.Footer>
  )
}

export default Footer
